import { t } from '@/lib/i18n';
import { Alert, Button, message } from 'antd';
import { useSession } from '../session/session-api';
import { useStopImpersonating } from './impersonation-api';
import { describeError } from '@/lib/http/http-api';

/** Persistent identity indicator, not a temporary operation notification. */
export const ImpersonationBanner = () => {
  const session = useSession();
  const stop = useStopImpersonating();
  if (!session.data?.session.impersonatedBy) return null;
  return (
    <Alert
      type="warning"
      banner
      aria-label={t('冒充状态')}
      title={t('正在冒充 {{name}}；当前操作使用该用户的权限。', {
        name: session.data.user.name,
      })}
      action={
        <Button
          className="shrink-0"
          loading={stop.isPending}
          onClick={() => {
            void stop.mutateAsync().catch((error: unknown) =>
              message.error(
                t('{{error}}。若原会话已失效，请退出并重新登录。', {
                  error: describeError(error),
                }),
              ),
            );
          }}
        >
          {t('停止冒充')}
        </Button>
      }
    />
  );
};
